// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Chat: React.FC = () => {
    return (
        <svg
            width="24px"
            height="24px"
            viewBox="0 0 18 15"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
        >
            <g id="Style-Guide" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g
                    id="UI-:-Iconography"
                    transform="translate(-512.000000, -212.000000)"
                    fill="#666666"
                    fillRule="nonzero"
                >
                    <path
                        d="M527.75,216.25 L524.25,216.25 L524.25,217.125 L527.75,217.125 C528.232344,217.125 528.625,217.517656 528.625,218 L528.625,223.25 C528.625,223.732344 528.232344,224.125 527.75,224.125 L526,224.125 L526,225.48043 L523.604687,224.125 L520.75,224.125 C520.267656,224.125 519.875,223.732344 519.875,223.25 L519.875,222.375 L519,222.374893 L519,223.249347 C519,224.213214 519.786133,224.974737 520.725391,224.974737 L523.375,225 L526.352735,226.685195 C526.41289,226.730859 526.481249,226.75 526.546875,226.75 C526.71914,226.75 526.875,226.616016 526.875,226.421875 L526.875,224.99918 L527.75,224.99918 C528.713867,224.99918 529.5,224.213047 529.5,223.273789 L529.5,217.975391 C529.5,217.034766 528.715234,216.25 527.75,216.25 Z M523.375,219.75 L523.375,214.475391 C523.375,213.536133 522.590234,212.75 521.625,212.75 L513.75,212.75 C512.786133,212.75 512,213.536133 512,214.475391 L512,219.725391 C512,220.715234 512.786133,221.5 513.75,221.5 L514.625,221.50029 L514.625,222.921875 C514.625,223.116016 514.783594,223.25 514.953125,223.25 C515.018066,223.25 515.086426,223.229492 515.147949,223.185059 L518.125,221.5 L521.625,221.497949 C522.590234,221.497265 523.375,220.715234 523.375,219.75 Z M517.895313,220.625 L515.5,221.98125 L515.5,220.625 L513.75,220.625 C513.267656,220.625 512.875,220.23125 512.875,219.75 L512.875,214.5 C512.875,214.017656 513.267656,213.625 513.75,213.625 L521.625,213.625 C522.107344,213.625 522.5,214.017656 522.5,214.5 L522.5,219.75 C522.5,220.232344 522.107344,220.625 521.625,220.625 L517.895313,220.625 Z"
                        id="icon_chat"
                    ></path>
                </g>
            </g>
        </svg>
    );
};

export default React.memo(Chat);
